import React, { FC, useEffect, useState } from 'react';
import { Title } from '../developers/page-components/Title';
import { Spinner } from '../Spinner';
import {
	DetailsRelatedTypes,
	getCaptureDate,
	getTotalAmount, getValue,
	getValueMark,
} from '../../utils/batchDetailsUtils';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { ISettlementsTableRowData } from '../../interfaces/funds';
import {
	commentInitialValues, convertToInitialCommentValues,
} from '../../constants/comment/comment-form';
import { useFormik } from 'formik';
import { SettlementsComments } from './SettlementsComments';

interface Props {
	loading: boolean,
	settlementDetailsDataById: ISettlementsTableRowData
}
export const SettlementsDetailsInformation: FC<Props> = (props) => {
	const { loading, settlementDetailsDataById } = props;

	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	const formik = useFormik({
		initialValues: commentInitialValues,
		onSubmit: () => void 0,
	});

	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

	useEffect(() => {
		const convertedData = convertToInitialCommentValues(settlementDetailsDataById);
		formik.setValues(convertedData);
	}, [settlementDetailsDataById]);

	const fields = [
		{
			fieldName: 'payments',
			title: 'payments',
			value: settlementDetailsDataById?.totalValue,
		},
		{
			fieldName: 'returns',
			title: 'returns',
			value: settlementDetailsDataById?.returns,
		},
		{
			fieldName: 'chargebacks',
			title: 'chargeback value',
			value: settlementDetailsDataById?.chargebacks,
		},
		{
			fieldName: 'processingFees',
			title: 'processing fees',
			value: settlementDetailsDataById?.flexChargeFees,
		},
		{
			fieldName: 'chargebackFees',
			title: 'chargeback fees',
			value: settlementDetailsDataById?.flexChargeChargebackFeesAmount,
		},
		{
			fieldName: 'adjustment',
			title: 'adjustment',
			value: settlementDetailsDataById?.adjustment,
		},
		{
			fieldName: 'reserveHold',
			title: 'reserve hold',
			value: settlementDetailsDataById?.reserveHold,
		},
		{
			fieldName: 'reserveRelease',
			title: 'reserve release',
			value: settlementDetailsDataById?.reserveRelease,
		},
		{
			fieldName: 'reserveUtilization',
			title: 'reserve utilization',
			value: settlementDetailsDataById?.reserveUtilization,
		},
	];

	if (loading) {
		return (
			<div className="card h-300px">
				<div className="card-body">
					<Spinner pageLoader/>
				</div>
			</div>
		);
	}

	if (!settlementDetailsDataById) {
		return (
			<div className="card h-300px">
				<div className="card-body d-flex align-items-center justify-content-center fs-4">
					No data found.
				</div>
			</div>
		);
	}

	return (
		<div className="card">
			<div className="card-body">
				{/*{*/}
				{/*	checkRoles(authUser, CLAIMS.SUPER_ADMIN) && (*/}
				{/*		<div className="pb-5 mb-5 payout-details-separator">*/}
				{/*			<MerchantNameLink mid={settlementDetailsDataById?.mid} />*/}
				{/*		</div>*/}
				{/*	)*/}
				{/*}*/}

				<div className="d-flex align-items-center pb-5 mb-5 payout-details-separator">
					<DetailsRelatedTypes
						sender={settlementDetailsDataById?.sender}
						receiver={settlementDetailsDataById?.receiver}
					/>

				</div>

				<div className="pb-5 mb-5 payout-details-separator">
					<Title title="Payouts" additionalClass="fw-bolder fs-6 me-2" />
					{getCaptureDate(settlementDetailsDataById?.capturePeriodFrom, settlementDetailsDataById?.capturePeriodTo)}
				</div>

				<div className="d-md-flex">
					<div className="col-md-6">
						{fields.map(({ fieldName, title, value }) => (
							<div key={fieldName}>
								<div className="d-flex align-items-center mb-2 fs-6">
									<div className="w-150px">{title}</div>
									<div>
										{getValueMark(fieldName, value) ? getValueMark(fieldName, value) : <span className="ms-1" />}
										{settlementDetailsDataById?.currencySymbol}{getValue(value)}
									</div>
								</div>
							</div>
						))}
					</div>

					<SettlementsComments formik={formik} additionalClass="d-none d-md-block col-md-6" />

				</div>


				<div className="pb-5 mb-5 payout-details-separator" />

				<div className="d-flex align-items-center justify-content-between">
					<div className="d-flex align-items-center fs-6 fw-bolder">
						<div className="w-150px fs-6 fw-bolder">Total payout</div>
						<div>{getTotalAmount(settlementDetailsDataById?.payoutAmount, settlementDetailsDataById?.currencySymbol)}</div>
					</div>
				</div>

				<div className="d-md-none pb-5 mb-5 payout-details-separator"/>

				<SettlementsComments formik={formik} additionalClass="d-md-none" />

			</div>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
		</div>
	);
};